import React from "react";
import {
  Box,
  Paper,
  List,
  ListSubheader,
  ListItem,
  ListItemText,
} from "@mui/material";
import { H9TitleSmall } from "../../../../components/StyledComponents/Typography/Typography.tsx";
import { StyledIconButton } from "../../../../components/StyledComponents/Buttons/AuradineButtons.js";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { format, parseISO } from "date-fns";
import { useTheme } from "../../../../ThemeContext/ThemeContext.js";

export const SiteDemand = React.memo((props) => {
  const { siteDemandData } = props;
  const { colors } = useTheme();
  console.log("siteDemandData", siteDemandData);
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        padding="0.25rem 0.5rem 0.25rem 1rem"
        alignItems={"center"}
      >
        <H9TitleSmall> Site Demand </H9TitleSmall>
        <StyledIconButton colors={colors}>
          <KeyboardArrowRightIcon
            fontSize="medium"
          />
        </StyledIconButton>
      </Box>
      <>
        <List
          sx={{
            width: "100%",
            backgroundColor: colors.background.accent,
            borderRadius: "1.5rem",
          }}
        >
          {Object.keys(siteDemandData).length > 0 &&
          siteDemandData.configName !== undefined ? (
            <>
              <ListItem>
                <ListItemText
                  sx={{ color: colors.text.primary }}
                >
                  {siteDemandData?.configName}
                </ListItemText>
              </ListItem>
              {Object.entries(siteDemandData).map(
                ([key, value]) =>
                  key === "configName" ? null : (
                    <ListItem key={key}>
                      <ListItemText
                        primary={key}
                        secondary={
                          key === "updatedAt"
                            ? format(
                                parseISO(value),
                                "MM/dd/yyyy HH:mm:ss"
                              )
                            : typeof value === "string"
                            ? value
                            : JSON.stringify(value)
                        }
                        sx={{
                          "& .MuiListItemText-primary": {
                            color: colors.text.primary,
                          },
                          "& .MuiListItemText-secondary": {
                            color: colors.text.muted,
                          },
                        }}
                      />
                    </ListItem>
                  )
              )}
            </>
          ) : (
            <ListItem>
              <ListItemText 
                secondary="Site demand data unavailable"
                sx={{
                  "& .MuiListItemText-secondary": {
                    color: colors.text.muted,
                  },
                }}
              />
            </ListItem>
          )}
        </List>
      </>
    </Box>
  );
});
